// ACTION TYPES //
export const CLOSE_MODAL = 'ui/close-modal'
export const SET_REPORT_PREVIEW = 'ui/set-report-preview'

// ACTIONS //
export const closeModal = () => ({
  type: CLOSE_MODAL
})

export const setReportPreview = (display = true) => ({
  type: SET_REPORT_PREVIEW,
  payload: display
})
